<style lang="scss" scoped>
.focus {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  outline: none;
}
.hasfilter {
  .autocomplete {
    border-bottom: 0;
  }
}
.autocomplete {
  border: 1px solid $c-dark-grey;
  background-color: $c-white;
  min-height: 35px;
  display: flex;
  flex-wrap: wrap;

  .item {
    display: inline-block;
    padding: 10px;
    background-color: $c-medium-blue;
    margin: 5px;

    svg {
      cursor: pointer;
    }
  }

  input {
    width: auto !important;
    border: none !important;
    outline: 0 !important;
  }
}

.filter {
  border: 1px solid $c-dark-grey;
  border-top: 0;

  .item {
    padding-left: 5px;
    transition: 0.2s all;
    background-color: $c-white;
    cursor: pointer;
    padding: 5px;
    &:hover {
      color: $c-white;
      background-color: $c-blue;
    }
  }
}
</style>

<template>
  <div class="autocompletecontainer" :class="{ hasfilter: filter != '', focus }">
    <div class="autocomplete" @click="onFocus">
      <div class="item" :key="item.label" v-for="item of model">
        {{ item.label }} <Icon :path="mdiClose" @click="removeFromList(item)" :width="15" :height="15" />
      </div>
      <input type="text" v-model="filter" ref="textbox" @blur="focus = false" />
    </div>
    <div class="filter" v-if="filter != ''">
      <div class="items">
        <div class="item" :key="item.label" v-for="item of filtered" @click="addToList(item)">
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mdiClose } from '@mdi/js';
import { computed, defineComponent, PropType, ref } from 'vue';

type AutoCompleteObject = {
  label: string;
  value: any;
};

export default defineComponent({
  props: {
    modelValue: { type: Object as PropType<Array<any>>, required: true },
    values: { type: Object as PropType<Array<AutoCompleteObject>>, required: true },
  },
  setup(props, { emit }) {
    const filter = ref<string>('');
    const textbox = ref<HTMLElement>();
    const focus = ref(false);
    const model = computed({
      get: () => props.modelValue,
      set: (id: Array<any>) => emit('update:modelValue', id),
    });

    const isSelected = (searchItem: AutoCompleteObject) => {
      if (undefined == model.value.find((item: AutoCompleteObject) => item.value == searchItem.value && item.label == searchItem.label)) return false;
      return true;
    };

    const filtered = computed(() => {
      return props.values.filter(
        (item: AutoCompleteObject) => filter.value != '' && item.label.toLowerCase().includes(filter.value.toLowerCase()) && !isSelected(item)
      );
    });

    const onFocus = () => {
      focus.value = true;
      textbox.value?.focus();
    };

    const addToList = (item: AutoCompleteObject) => {
      if (!isSelected(item)) {
        model.value.push(item);
        filter.value = '';
      }
    };

    const removeFromList = (item: AutoCompleteObject) => {
      model.value = model.value.filter((searchItem: AutoCompleteObject) => searchItem.value != item.value && searchItem.label != item.label);
    };

    return {
      model,
      filter,
      filtered,
      focus,
      onFocus,
      textbox,
      addToList,
      removeFromList,
      mdiClose,
    };
  },
});
</script>
